import { cn } from "../../utils";
import { useTableContext } from "./context";
import { TableLoadingRow } from "./TableLoadingRow";
import { TableRow } from "./TableRow";

type Props = {
  className?: string;
  skeletonRows: number;
};

export function TableBody<Item>({ className, skeletonRows }: Props) {
  const { items, loading } = useTableContext<Item>();

  if (loading) {
    return (
      <div
        className={cn(
          "flex flex-col min-w-fit [&>*:last-child]:border-b-0",
          className,
        )}
      >
        {Array.from({ length: skeletonRows }, (_, index) => (
          <TableLoadingRow key={`loading-row-${index}`} />
        ))}
      </div>
    );
  }

  return (
    <div
      className={cn(
        "flex flex-col min-w-fit [&>*:last-child]:border-b-0",
        className,
      )}
    >
      {items.map((item, index) => {
        return <TableRow key={`row-${index}`} item={item} />;
      })}
    </div>
  );
}
